import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';

import { CollectionType } from '@/enums/collection-type';

import Provider from '@/interfaces/provider';
import { PopularTabType } from '@/interfaces/titles';

import { FilterCollection } from '@/stores/filter.store';

import FilterBarPopularProvider from './FilterBarPopularProvider.vue';
import Top10Titles from './Top10Titles.vue';
import FilterBarContentTypeSeo from '@/components/filter-bar/seo/FilterBarContentTypeSeo.vue';

import { useConstantStore, useRoutingStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderModule',
  props: {
    collectionType: null,
    currentFilters: null,
    providersInMenu: { type: Boolean, default: false },
    provider: null,
    selectedTab: null,
    amount: null
  },
  emits: ["done"],
  setup(__props: any, { emit }: { emit: ({ (e: 'done'): void }), expose: any, slots: any, attrs: any }) {





onMounted(() => emit('done'));

const { providers } = useConstantStore();
const userProviders = computed(() => providers.value());

const { activeRoute } = useRoutingStore();
const newPageType = computed(() => activeRoute?.value.meta?.newPageType);

return { __sfc: true,emit, providers, userProviders, activeRoute, newPageType, FilterBarPopularProvider, Top10Titles, FilterBarContentTypeSeo }
}

})